import { render } from "./goods_kinds.html?vue&type=template&id=f6f7939e&scoped=true&external"
import script from "./goods_kinds.vue?vue&type=script&lang=js"
export * from "./goods_kinds.vue?vue&type=script&lang=js"

import "./goods_kinds.vue?vue&type=style&index=0&id=f6f7939e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6f7939e"]])

export default __exports__